<template>
    <MdModal v-if="showEditModal" :data-qa-id="`edit-${inputField}-modal`" id="edit-info-modal" width="600px"
        :isopen="showEditModal" @handleclose="closeModal" enablebackdropclick="false" showoverlay="true"
        :bordered="bordered" class="edit-info-modal">
        <div slot="header" class="edit-info-modal--header">
            <MdTypography :data-qa-id="`edit-${inputField}-modal--heading`" tag="h5" variant="heading5--medium">
                {{modalTexts?.heading}}
            </MdTypography>
            <MdTypography :data-qa-id="`edit-${inputField}-modal--details`" tag="p" color="spirits--700"
                variant="body2--regular">
                {{modalTexts?.details}}
            </MdTypography>
        </div>
        <div slot="body" class="edit-info-modal--body">
            <div class="edit-info-modal--input">
                <MdTypography v-if="inputConfig?.showLabel || false" :data-qa-id="`edit-${inputField}-modal--inputLabel`" tag="p" color="spirits--900"
                variant="body2--medium">
                    {{inputConfig?.labelText || '-'}}
                    <span class="required-star">*</span>
                </MdTypography>
                <TextField 
                    :id="`${inputField}-bulkEdit-input-id`" 
                    :data-qa-id="`edit-${inputField}-modal--inputField`"
                    :name="`${inputField}-bulkEdit-input`" 
                    v-model="inputValue" 
                    :placeholder="inputConfig.placeholder"
                    :maxLength="inputConfig.maxLength"
                    :modelValue="inputValue" 
                    :rules="inputConfig.validationRules" 
                    :keyUp="handleKeyUpPress"
                    :handleNumberInput="handleKeyInput" 
                    :showFirstOptionalText="inputConfig.showOptionalText"
                    :firstOptionalText="inputConfig.optionalText" 
                />
            </div>
            <MdTypography :data-qa-id="`edit-${inputField}-modal--subHeading`" tag="p" color="spirits--900"
                variant="heading7--medium">
                {{modalTexts?.impactedDataHeading}}
            </MdTypography>
            <div class="ag-grid-container" :style="minHeightStyle">
                <agGrid 
                    v-if="rowData.length > 0" 
                    class="edit-info-modal--body-table" 
                    :data-qa-id="`edit-${inputField}-modal--table`"
                    :columnDefs="colDefs" 
                    :rowData="rowData" 
                    :isPagination="false" 
                />
            </div>
        </div>
        <div slot="footer" class="edit-info-modal--footer">
            <MdButton :data-qa-id="`edit-${inputField}-modal--cancelButton`" @click="closeModal" size="large"
                color="lightgrey">
                {{$t('pages.inventory_ingestion_hub.edit_info_modal.cancel_button')}}
            </MdButton>
            <MdButton :data-qa-id="`edit-${inputField}-modal--setButton`" @click="setUpdatedData"
                :disabled="disableSubmit" size="large">
                {{modalTexts?.submitButtonText}}
            </MdButton>
        </div>
    </MdModal>
</template>